import { useEffect, useRef } from 'react';

// Closing print preview removes the hash from the URL, so we need to
// restore it so the user stays on the same page
const usePersistHashOnPrint = () => {
  const hashWhenPrinting = useRef(null);

  const afterPrint = () => {
    hashWhenPrinting.current = window.location.hash;
  };

  const onHashChange = () => {
    if (!hashWhenPrinting.current) return;

    window.location.hash = hashWhenPrinting.current;
    hashWhenPrinting.current = null;
  };

  useEffect(() => {
    window.addEventListener('afterprint', afterPrint);
    window.addEventListener('hashchange', onHashChange);

    return () => {
      window.removeEventListener('afterprint', afterPrint);
      window.removeEventListener('hashchange', onHashChange);
    };
  }, []);
};

export default usePersistHashOnPrint;
